<template>
  <div id="app" class="overflow-auto">
    <router-view />
    <div class="background-box"></div>
  </div>
</template>

<script>
export default {
  created() {
    const bus = this.$bus
    if (!bus.currentBrowserInfo.isPc) {
      window.location.replace(window.location.href.replace('pc', 'transfer'))
    }
  },
  mounted() {}
}
</script>
